/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sectionheader_Seeall2Inputs */

const id_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat semua`)
};

const ms_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat semua`)
};

const da_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se alle`)
};

const de_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle ansehen`)
};

const en_us2_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all`)
};

const es_es2_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos`)
};

const es_mx2_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos`)
};

const fil_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingnan lahat`)
};

const fr_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir tout`)
};

const it_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi tutto`)
};

const hu_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összes megtekintése`)
};

const nl_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles bekijken`)
};

const no_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se alle`)
};

const pl_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz wszystkie`)
};

const pt_br2_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all`)
};

const pt_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver tudo`)
};

const ro_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezi toate`)
};

const fi_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä kaikki`)
};

const sv_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se alla`)
};

const vi_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem tất cả`)
};

const tr_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tümünü gör`)
};

const cs_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit vše`)
};

const bg_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вижте всички`)
};

const ru_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотреть все`)
};

const uk_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переглянути всі`)
};

const ar_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض الكل`)
};

const hi_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी देखें`)
};

const th_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูทั้งหมด`)
};

const ja_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて見る`)
};

const zh_cn2_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all`)
};

const zh_hant1_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all`)
};

const ko_components_sectionheader_seeall2 = /** @type {(inputs: Components_Sectionheader_Seeall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all`)
};

/**
* | output |
* | --- |
* | "See all" |
*
* @param {Components_Sectionheader_Seeall2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sectionheader_seeall2 = /** @type {((inputs?: Components_Sectionheader_Seeall2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sectionheader_Seeall2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sectionheader_seeall2(inputs)
	if (locale === "ms") return ms_components_sectionheader_seeall2(inputs)
	if (locale === "da") return da_components_sectionheader_seeall2(inputs)
	if (locale === "de") return de_components_sectionheader_seeall2(inputs)
	if (locale === "en-US") return en_us2_components_sectionheader_seeall2(inputs)
	if (locale === "es-ES") return es_es2_components_sectionheader_seeall2(inputs)
	if (locale === "es-MX") return es_mx2_components_sectionheader_seeall2(inputs)
	if (locale === "fil") return fil_components_sectionheader_seeall2(inputs)
	if (locale === "fr") return fr_components_sectionheader_seeall2(inputs)
	if (locale === "it") return it_components_sectionheader_seeall2(inputs)
	if (locale === "hu") return hu_components_sectionheader_seeall2(inputs)
	if (locale === "nl") return nl_components_sectionheader_seeall2(inputs)
	if (locale === "no") return no_components_sectionheader_seeall2(inputs)
	if (locale === "pl") return pl_components_sectionheader_seeall2(inputs)
	if (locale === "pt-BR") return pt_br2_components_sectionheader_seeall2(inputs)
	if (locale === "pt") return pt_components_sectionheader_seeall2(inputs)
	if (locale === "ro") return ro_components_sectionheader_seeall2(inputs)
	if (locale === "fi") return fi_components_sectionheader_seeall2(inputs)
	if (locale === "sv") return sv_components_sectionheader_seeall2(inputs)
	if (locale === "vi") return vi_components_sectionheader_seeall2(inputs)
	if (locale === "tr") return tr_components_sectionheader_seeall2(inputs)
	if (locale === "cs") return cs_components_sectionheader_seeall2(inputs)
	if (locale === "bg") return bg_components_sectionheader_seeall2(inputs)
	if (locale === "ru") return ru_components_sectionheader_seeall2(inputs)
	if (locale === "uk") return uk_components_sectionheader_seeall2(inputs)
	if (locale === "ar") return ar_components_sectionheader_seeall2(inputs)
	if (locale === "hi") return hi_components_sectionheader_seeall2(inputs)
	if (locale === "th") return th_components_sectionheader_seeall2(inputs)
	if (locale === "ja") return ja_components_sectionheader_seeall2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sectionheader_seeall2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sectionheader_seeall2(inputs)
	return ko_components_sectionheader_seeall2(inputs)
});
export { components_sectionheader_seeall2 as "components.sectionHeader.seeAll" }